// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgTune24 = forwardRef(({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
	let ariaLabelledBy = titleid ? titleid : "";
	ariaLabelledBy += desc && descid ? ` ${descid}` : "";
	ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
	props["aria-labelledby"] = ariaLabelledBy;
	return (
		<Svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			title={title}
			titleid={titleid}
			desc={desc}
			descid={descid}
			aria-labelledby={ariaLabelledBy}
			aria-hidden={!ariaLabelledBy}
			ref={ref}
			{...props}
		>
			{!!title && <title id={titleId}>{title}</title>}
			{!!desc && <desc id={descId}>{desc}</desc>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.5 1.25C7.91421 1.25 8.25 1.58579 8.25 2V9C8.25 9.41421 7.91421 9.75 7.5 9.75C7.08579 9.75 6.75 9.41421 6.75 9V2C6.75 1.58579 7.08579 1.25 7.5 1.25ZM11 15.5C11 13.567 9.433 12 7.5 12C5.567 12 4 13.567 4 15.5C4 17.1774 5.17996 18.5792 6.75512 18.9206L6.75 19V22C6.75 22.4142 7.08579 22.75 7.5 22.75C7.91421 22.75 8.25 22.4142 8.25 22V19L8.24587 18.9204C9.82053 18.5786 11 17.177 11 15.5ZM5.5 15.5C5.5 14.3954 6.39543 13.5 7.5 13.5C8.60457 13.5 9.5 14.3954 9.5 15.5C9.5 16.6046 8.60457 17.5 7.5 17.5C6.39543 17.5 5.5 16.6046 5.5 15.5ZM17.25 2C17.25 1.58579 16.9142 1.25 16.5 1.25C16.0858 1.25 15.75 1.58579 15.75 2L15.7512 5.04018L15.7551 5.07943C14.18 5.42084 13 6.82262 13 8.5C13 10.433 14.567 12 16.5 12C18.433 12 20 10.433 20 8.5C20 6.82298 18.8205 5.42143 17.2459 5.07965L17.25 5V2ZM16.5 6.5C15.3954 6.5 14.5 7.39543 14.5 8.5C14.5 9.60457 15.3954 10.5 16.5 10.5C17.6046 10.5 18.5 9.60457 18.5 8.5C18.5 7.39543 17.6046 6.5 16.5 6.5ZM17.25 15C17.25 14.5858 16.9142 14.25 16.5 14.25C16.0858 14.25 15.75 14.5858 15.75 15V22C15.75 22.4142 16.0858 22.75 16.5 22.75C16.9142 22.75 17.25 22.4142 17.25 22V15Z"
			/>
		</Svg>
	);
});
SvgTune24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgTune24;
